<template>
  <modal
    id="modalDisciplinas"
    :exibir="exibir"
    :titulo="titulo"
    :campos="$refs"
    tamanho="xl"
    :ocultarRodape="true"
    @fechar="fechar"
  >
    <div class="row">
      <div class="col-md-4">
        <input-select-search
          ref="disciplina"
          v-model="novaDisciplina.disciplinaId"
          label="Disciplina"
          :options="opcoesDisciplinasFormated"
          required
        />
      </div>
      <div class="col-md-4">
        <input-select-search
          ref="media"
          v-model="novaDisciplina.tipoMediaEnum"
          label="Média"
          :options="opcoesMedia"
          required
        />
      </div>
      <div class="col-md-4">
        <input-text
          type="number"
          ref="cargaHorariaDisciplina"
          v-model="novaDisciplina.cargaHoraria"
          label="Carga Horária"
          :min="1"
          required
        />
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="fechar">
        {{ $t('GERAL.FECHAR') }}
      </b-button>

      <b-button variant="primary" @click="adicionar">
        {{ estaEditando ? 'Editar' : 'Adicionar' }}
      </b-button>
    </div>
  </modal>
</template>

<script>
// Utils & Aux:e/Store';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';
import mensagem from '@/common/utils/mensagem';

// Components:
import { InputSelectSearch, InputText } from '@/components/inputs';
import Modal from '@/components/modal/Modal';

export default {
  mixins: [Permissoes],
  props: {
    exibir: Boolean,
    form: Object,
    opcoesDisciplinas: Array,
    opcoesMedia: Array,
    disciplinaSelecionada: Object
  },
  components: {
    Modal,
    InputSelectSearch,
    InputText,
  },
  data() {
    return {
      estaEditando: false,
      novaDisciplina: {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
      },
      colunasDisciplina: [
        { key: 'codigo', label: 'Disciplina' },
        { key: 'disciplinaDescricao', label: 'Descrição' },
        { key: 'tipoMediaEnumDescricao', label: 'Média' },
        { key: 'cargaHoraria', label: 'Carga horária' },
        { key: 'acoes', label: 'Ações' }
      ]
    }
  },
  watch: {
    disciplinaSelecionada: {
      async handler(value) {
        if (value.index != null) {
          this.estaEditando = true;
          this.novaDisciplina = {
            disciplinaId: value.item.disciplinaId,
            tipoMediaEnum: value.item.tipoMediaEnum,
            cargaHoraria: value.item.cargaHoraria,
            index: value.index
          };
        }
      },
      deep: true
    }
  },
  computed: {
    titulo() {
      return this.estaEditando 
        ? this.$t('ACADEMICO_TURMAS.EDITAR_DISCIPLINA') 
        : this.$t('ACADEMICO_TURMAS.ADICIONAR_DISCIPLINA');
    },
    opcoesDisciplinasFormated() {
      let lista = this.opcoesDisciplinas.filter(i => {
        return !this.form.disciplinas.find(disciplina => i.id == disciplina.disciplinaId);
      });
      if (this.estaEditando) {
        let novoitem = this.opcoesDisciplinas.find(i => i.id == this.novaDisciplina.disciplinaId);
        lista.push(novoitem);
      }
      return lista;
    }
  },
  methods: {
    adicionar() {
      if (!this.validarFormulario()) return;
      this.$emit("salvarDisciplina", this.novaDisciplina);

      this.fechar();
    },
    validarFormulario() {
      const totalCargaHoraria = this.form.disciplinas
        .map((disciplina) => parseInt(disciplina.cargaHoraria))
        .reduce((acc, cargaHoraria) => acc + cargaHoraria, 0);
      if (totalCargaHoraria > this.form.cargaHoraria) {
        mensagem.erro(
          this.$t('GERAL.ERRO'),
          this.$t(
            'A soma da Carga Horária das disciplinas está maior que a Carga Horária da turma'
          )
        );
        return;
      }
      return helpers.validarFormulario(this.$refs);
    },
    fechar() {
      this.novaDisciplina = {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
      };
      this.$emit('fechar');
      this.estaEditando = false;
    }
  }
}
</script>
